function capitalizeWord(string) {
  if (!string) {
    return '';
  }

  return string.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
}

export default capitalizeWord;
